import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { updateAthleteResult } from "../../../../data-store/actions/events-actions";

const useStyles = makeStyles((theme) => ({
  row: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  paper: {
    border: `1px solid ${theme.palette.divider}`, // "bordered"
    overflow: "hidden",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    "& th, & td": {
      textAlign: "center", // "centered"
      borderBottom: `1px solid ${theme.palette.divider}`, // "bordered"
    },
    "& thead th": {
      fontWeight: 600,
      background: theme.palette.action.hover,
    },
    "& tbody tr:last-child td": {
      borderBottom: "none",
    },
  },
}));

// Props:
// - resultado: contiene extraData.notes
// - eventDetail: { iDEvento }
// - userID: string
// - eventUsers: diccionario de usuarios para imprimir nombre
const AtleteBitacory = ({ resultado, eventDetail, userID, eventUsers }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [noteText, setNoteText] = useState("");
  const [notes, setNotes] = useState(resultado?.extraData?.notes || []);
  const [saving, setSaving] = useState(false);

  // Sincroniza si cambia resultado
  useEffect(() => {
    setNotes(resultado?.extraData?.notes || []);
  }, [resultado]);

  const handleSave = async () => {
    const text = noteText.trim();
    if (!text) return;

    const newNote = {
      description: text,
      date: new Date().toISOString(),
      userId: userID,
    };

    const newNotes = [...(notes || []), newNote];

    // Optimista en UI
    setNoteText("");
    setSaving(true);

    const payload = {
      recalcular: true,
      extraData: {
        ...(resultado?.extraData || {}),
        notes: newNotes,
      },
    };

    try {
      await dispatch(
        updateAthleteResult(
          "evento_" + eventDetail.iDEvento,
          resultado.num,
          payload
        )
      );
    } catch (e) {
      // Revertir si falla
      setNotes(notes);
      setNoteText(text);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Grid container spacing={2}>
      {/* Título, similar a row + col s10 */}
      <Grid item xs={12} className={classes.row}>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            <Typography variant="h5">Bitácora del Atleta</Typography>
          </Grid>
          {saving && (
            <Grid item>
              <CircularProgress size={16} />
            </Grid>
          )}
        </Grid>
      </Grid>


      <Grid item xs={12} className={classes.row}>
        <Grid container justify="center">
          <Grid item xs={12} md={8}>
            <Paper elevation={2} className={classes.paper}>
              <Table size="small" className={classes.table} id="DetalleComp">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: 180 }}>Fecha / Hora</TableCell>
                    <TableCell>Descripción</TableCell>
                    <TableCell style={{ width: 220 }}>Usuario</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(!notes || notes.length === 0) && (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        No hay notas registradas
                      </TableCell>
                    </TableRow>
                  )}
                  {notes?.map((note, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {note?.date
                          ? new Date(note.date).toLocaleString()
                          : "-"}
                      </TableCell>
                      <TableCell>{note?.description || ""}</TableCell>
                      <TableCell>
                        {eventUsers?.[note?.userId]?.nombreJuez || note?.userId || "-"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.row}>
        <Grid container justify="center" spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Escribe una nota"
              fullWidth
              multiline
              rows={2}
              value={noteText}
              onChange={(e) => setNoteText(e.target.value)}
              disabled={saving}
            />
          </Grid>
          <Grid item xs={12} md={2} style={{ display: "flex" }}>
            <Button
              variant="contained"
              color="primary"
              style={{ width: "100%", alignSelf: "stretch" }}
              onClick={handleSave}
              disabled={saving || !noteText.trim()}
            >
              {saving ? "Guardando..." : "Guardar"}
            </Button>
          </Grid>
        </Grid>
      </Grid>

    </Grid>
  );
};

export default AtleteBitacory;
